import FullTableLayout from './FullTableLayout';
import ProjectBobinState from '../production-management/ProjectBobinState';
import { FULL_TABLE_PARENTS } from './routes';

/**
 * Project Token State, on its own page. Same component, same filters, same
 * phantom / plan-ahead / orders-stock views — it just gets the whole viewport,
 * so it shows a much taller page of tokens.
 */
const ProjectTokenStateFull = () => (
  <FullTableLayout
    backTo={FULL_TABLE_PARENTS.projectMonitor}
    backLabel="Project Monitor"
  >
    <ProjectBobinState fullPage />
  </FullTableLayout>
);

export default ProjectTokenStateFull;
